export const EnvironmentUtil = {
  apiV1Url: (path: string): string => `${process.env.REACT_APP_API_URL}/api/${path}`,
  apiV2Url: (path: string): string => `${process.env.REACT_APP_API_URL}/v2/${path}`,
  apiV3Url: (path: string): string => `${process.env.REACT_APP_API_URL}/v3/${path}`,
  identityServerUrl: (path: string): string =>
    `${process.env.REACT_APP_IDENTITY_SERVER_URL}/${path}`,
  frontendUrl: (path: string): string => `${process.env.REACT_APP_FRONTEND_URL}/#/${path}`,
  isMixNetwork: (window.location.href).includes(process.env.REACT_APP_MIX_FRONTEND_URL || "") || (window.location.href).includes(process.env.REACT_APP_CALLZA_FRONTEND_URL || ""),  
  isCspire: (window.location.href).includes(process.env.REACT_APP_Cspire_FRONTEND_URL || ""),
  isqa: (window.location.href).includes(process.env.REACT_APP_Qa_FRONTEND_URL || ""),
  istest: (window.location.href).includes(process.env.REACT_APP_Test_FRONTEND_URL || ""),
  isdev: (window.location.href).includes(process.env.REACT_APP_Dev_FRONTEND_URL || ""),
  isMixQa: (window.location.href).includes(process.env.REACT_APP_Dev_MIX_QA_FRONTEND_URL || ""),
  isMixUat: (window.location.href).includes(process.env.REACT_APP_Dev_MIX_UAT_FRONTEND_URL || ""),
  isPrdUrl: (window.location.href).includes(process.env.REACT_APP_FRONTEND_URL || ""),
  isPrdMixUrl: (window.location.href).includes(process.env.REACT_APP_MIX_FRONTEND_URL || ""),
  isCallza: (window.location.href).includes(process.env.REACT_APP_CALLZA_FRONTEND_URL || ""),  
  signalRUrl: `${process.env.REACT_APP_API_URL}/hub/notification`,
  oAuthClientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
  oAuthClientSecret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
  oAuthScope: process.env.REACT_APP_OAUTH_SCOPE,
  version: process.env.REACT_APP_BUILD
};
